import { useEffect, useState } from 'react';
import { useSEO } from '../../utils/seo';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TechFeatures from './components/TechFeatures';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Appointment from './components/Appointment';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useSEO({
    title: 'Denizli Araç Servisi | Premium Araç Bakım ve Onarım Hizmetleri',
    description: 'Denizli\'de üst segment araçlar için profesyonel otomotiv servisi. DR.ECU yetkili bayi, motor rektifiye, kaza onarımı, şanzıman tamiri ve araç check-up hizmetleri. 15 yıllık deneyim ve son teknoloji ekipmanlar ile Merkezefendi\'nde hizmetinizdeyiz.',
    keywords: 'denizli otomotiv servisi, denizli araç tamiri, denizli motor rektifiye, denizli DR.ECU, denizli kaza onarımı, denizli şanzıman tamiri, denizli araç bakımı, merkezefendi oto servis',
    canonical: '/',
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'AutomotiveBusiness',
      name: 'D-Atolye Premium Otomotiv Servisi',
      description: 'Denizli\'de üst segment araçlar için profesyonel otomotiv servisi. DR.ECU yetkili bayi, motor rektifiye, kaza onarımı, şanzıman tamiri ve araç check-up hizmetleri.',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      telephone: '+90-258-123-4567',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Sümer Mahallesi, 2467/1 Sokak, No:1',
        addressLocality: 'Merkezefendi',
        addressRegion: 'Denizli',
        postalCode: '20020',
        addressCountry: 'TR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 37.7765,
        longitude: 29.0864,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '09:00',
          closes: '14:00',
        },
      ],
      priceRange: '$$',
      image: 'https://static.readdy.ai/image/5946f8dc6d1689a139aced3671fb829b/5627d08f05dce4eda6468c71266b611d.png',
      sameAs: [
        'https://www.facebook.com/datolye',
        'https://www.instagram.com/datolye',
      ],
    },
  });

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`min-h-screen bg-white transition-opacity duration-700 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      <Navbar />
      <Hero />
      <TechFeatures />
      <Services />
      <WhyChooseUs />
      <Appointment />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}